import DrawerButton from "components/form/DrawerButton";
import Error from "components/form/Error";
import LabelArea from "components/form/LabelArea";
import Title from "components/form/Title";
import usePermitSubmit from "hooks/usePermitSubmit";
import DynamicPermitInput from "components/form/DynamicPermitInput";
import SelectStateSingle from "components/form/SelectStateSingle";
import React from "react";
import Scrollbars from "react-custom-scrollbars-2";

const PermitDrawer = ({ id }) => {
  const {
    setSelectedOptions,
    selectedOptions,
    handleVehicleCategoryChange,
    setDataInput,
    dataInput,
    handleChangeInput,
    register,
    handleSubmit,
    selectedFromState,
    selectedEndState,
    onSubmit,
    trigger,
    errors,
    setSelectedEndState,
    setSelectedFromState,
    loading,
  } = usePermitSubmit(id);
  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title title={"Edit Permit"} description={""} />
        ) : (
          <Title title={"Add Permit"} description={""} />
        )}
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-6 pt-8 flex-grow scrollbar-hide w-full max-h-full pb-40">
            <div className="grid grid-cols-12 gap-x-3 gap-y-7 mb-8">
              <div className="col-span-6">
                <LabelArea label={"Start State"} required />
                <SelectStateSingle
                  register={register}
                  label="Start State"
                  name="from_state"
                  type="text"
                  placeholder={"--Choose--"}
                  selectedCountryId={110}
                  selectedState={selectedFromState}
                  handleStateChange={setSelectedFromState}
                />
                <Error errorName={errors.from_state} />
              </div>

              <div className="col-span-6">
                <LabelArea label={"End State"} required />
                <SelectStateSingle
                  register={register}
                  label="End State"
                  name="to_state"
                  type="text"
                  placeholder={"--Choose--"}
                  selectedCountryId={110}
                  selectedState={selectedEndState}
                  handleStateChange={setSelectedEndState}
                />
                <Error errorName={errors.to_state} />
              </div>
            </div>
            <DynamicPermitInput
              register={register}
              trigger={trigger}
              errors={errors}
              dataInput={dataInput}
              setDataInput={setDataInput}
              handleChange={handleChangeInput}
              selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}
              handleVehicleCategoryChange={handleVehicleCategoryChange}
            />
          </div>

          <DrawerButton
            isSubmitting={loading}
            id={id}
            title={id ? "Update" : "Submit"}
          />
        </form>
      </Scrollbars>
    </>
  );
};

export default PermitDrawer;
